(() => {
  const C = window.JoffzProductConfigurator;
  if (!C || C.prototype.__jpcV77SourceGeometry) return;
  C.prototype.__jpcV77SourceGeometry = true;
  C.prototype.__jpcV22Geometry = true;
  C.prototype.__jpcV22Scale = true;

  // Display geometry follows the artwork, never the purchasable size option.
  C.prototype.calculateSizeScale = function calculateSizeScaleV77() { return 1; };
  C.prototype.getArtworkAspectRatioV77 = function getArtworkAspectRatioV77() {
    const image = this.querySelector('[data-jpc-preview-image]');
    const width = Number(image?.getAttribute('width')) || Number(image?.naturalWidth);
    const height = Number(image?.getAttribute('height')) || Number(image?.naturalHeight);
    if (Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0) {
      this.__jpcSourceRatioV77 = width / height;
    }
    if (!(this.__jpcSourceRatioV77 > 0)) {
      const initial = Number(this.style.getPropertyValue('--jpc-artwork-ratio'));
      this.__jpcSourceRatioV77 = Number.isFinite(initial) && initial > 0 ? initial : 0.75;
    }
    return this.__jpcSourceRatioV77;
  };

  // Preserve the physical-size helper for any existing consumers.
  C.prototype.getSizeAspectRatio = function getSizeAspectRatioV77(size) {
    const metric = this.sizeMetrics.get(size) || this.parsePhysicalSize(size);
    const width = Number(metric?.width);
    const height = Number(metric?.height);
    return Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0 ? width / height : null;
  };

  const baseUpdatePreview = C.prototype.updatePreview;
  C.prototype.updatePreview = function updatePreviewV77SourceGeometry(state) {
    const ratio = this.getArtworkAspectRatioV77();
    if (typeof baseUpdatePreview === 'function') baseUpdatePreview.call(this, state);
    const value = String(ratio);
    if (this.style.getPropertyValue('--jpc-artwork-ratio') !== value) this.style.setProperty('--jpc-artwork-ratio', value);
    if (this.style.getPropertyValue('--jpc-source-ratio') !== value) this.style.setProperty('--jpc-source-ratio', value);
    if (this.dataset.jpcRatioSource !== 'artwork') this.dataset.jpcRatioSource = 'artwork';
    if (this.dataset.jpcPrintRatio !== value) this.dataset.jpcPrintRatio = value;
  };
})();
